import CurateInside from "../../../assets/images/curate-inside.jpg";
export const storeFrontData = [
  {
    id: "brand_partnership",
    laptopTitle: "Establish Profitable Brand Partnerships.",
    mobileTitle: "Establish Profitable Brand Partnerships.",
    para: "Represent your favorite brands and develop profitable partnerships with the brands you love, thanks to Splendid’s unmatched brand-building features. Be part of campaigns, buy samples, get gifted, get paid per click, and most importantly, earn commissions on sales. Essentially you can be part of.",
    otherPara: "",
    liArray: [
      {
        point:
          "Sales Campaigns – enabling you to sell your favorite brands and products to your followers.",
      },
      {
        point:
          "Pay-per-click campaigns – you get invited by brands to be part of their pay-per-click campaigns. Essentially, you get paid for every click.",
      },
      {
        point:
          "Sampling Campaigns – purchase samples at never-seen-before prices and enhance your content creation journey.",
      },
      { point: "Gifting Campaigns – As a top creator, get gifted by brands." },
    ],
    imageSrc: CurateInside,
  },
  {
    id: "digital_storefront",
    laptopTitle: "Curate A Digital Storefront.",
    mobileTitle: "Curate A Digital Storefront.",
    para: "Easily create a beautiful, customizable storefront for your favorite product recommendations. Share shoppable posts, links, and custom collections of your favorite products and recommendations seamlessly.",
    otherPara: "",
    liArray: [
      {
        point:
          "Make your content shoppable – connect your social accounts to monetize your content with shoppable social feeds for Instagram, YouTube, and Facebook.",
      },
      {
        point:
          "Get invited to campaigns –  have direct conversations with brands and earn more commissions, get paid for clicks, purchase samples, and get gifted. ",
      },
    ],
    imageSrc: CurateInside,
  },
];
